export interface CommodityUnloadTimeResource {
    commodityCode : string;
    timePerUnit: string;
    createdDate: Date;
    createdBy: string;
    updatedDate: Date;
    updatedBy: string;
}

export interface GetCommodityUnloadTimesRequest{
    commodityCode : string;
}

export interface CreateCommodityUnloadTimeRequest {
    commodityCode : string;
    timePerUnit: string;
}

export interface CreateCommodityUnloadTimeResource {
    commodityCode : string;
}

export class EditCommodityUnloadTimeModel {
    commodityCode : string;
    timePerUnit: string;
    visible: boolean = true;
    saving: boolean = false;
  
    toCreateRequest(): CreateCommodityUnloadTimeRequest {
      return { commodityCode: this.commodityCode, timePerUnit: this.timePerUnit };
    }
  }